'use strict';

import React from 'react';
import { useEffect, useState, useRef, useMemo } from 'react';

import { Button, Form, Stack, Row, Col } from 'react-bootstrap';

import { Formik } from 'formik';
import * as yup from 'yup';

import useRequest from '../helper/useRequest';

import { toast } from 'react-toastify';

import Tooltip from '../helper/Tooltip';

import Select from 'react-select';

import { date, timeStart, timeEnd, grade, nameClass } from '../helper/Schema';

import MandatoryFieldNotice from '../helper/MandatoryFieldNotice';

function validateTimes(start, end, minDiff) {
    let s = {};
    let e = {};
    if (start.length) { s = new Date("1970-01-01 " + start); }
    else return false;
    if (end.length) { e = new Date("1970-01-01 " + end); }
    else return false;

    let diff = e.getTime() - s.getTime();
    let check = 60000 * minDiff;
    return diff >= check;
}

function CreateTimeslot() {
    const [equipment, setEquipment] = useState([]);
    const [categories, setCategories] = useState([]);
    const [contactPersons, setContactPersons] = useState([]);
    const [startTime, setStartTime] = useState("00:00:00");
    const { request } = useRequest();

    const formRef = useRef(null);

    const schema = {
        date: date.test("checkDate", "Es kann kein Termin an einem Sonntag stattfinden.", (value) => { return value.getDay() > 0; }),
        timeStart: timeStart,
        timeEnd: timeEnd.test("checkEndTime", "Die Endzeit muss mindestens 30 Minuten nach der Startzeit liegen.", (value) => { return validateTimes(startTime, value, 30); }),
        nameClass: nameClass
    };

    const createTimeslot = async (values) => {
        let data = {
            Date: values.date,
            TimeStart: values.timeStart,
            TimeEnd: values.timeEnd,
            Grade: values.grade,
            NameClass: values.nameClass,
            Room: null,
            Expiration: values.expiration,
            Equipment: values.equipment.map(({ value }) => (parseInt(value))),
            Categories: values.categories.map(({ value }) => (parseInt(value))),
            ContactPerson: values.contactPerson.value,
            CriminalRecord: values.criminalRecord
        };

        if (values.room) {
            data.Room = values.roomName;
        }
        
        try {
            if (data.Expiration < 0) {
                toast.error(unescape("Die eingegebene Ablaufzeit %28in Stunden vor Termin-Begin%29 ist negativ. Bitte %E4ndern Sie Ihre Eingabe auf eine positive Ganzzahl."));
            }
            else {
                let result = await request("/School/MakeTimeslot", data);
                let json = result.data;
                if (json.r != 1) {
                    if (json.message) {
                        toast.error(json.message);
                    }
                    else {
                        toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
                    }
                }
                else {
                    toast.success("Termin erstellt.");
                }
            }           
        }
        catch {
            toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.");
        }
    }

    useEffect(() => {
        const setSearchParameter = (json) => {
            const searchParams = new URLSearchParams(window.location.search);
 
            if (searchParams.get("d")) {
                formRef.current.setFieldValue("date", searchParams.get("d"));
            }
            if (searchParams.get("ts")) {
                formRef.current.setFieldValue("timeStart", searchParams.get("ts"));
            }
            if (searchParams.get("te")) {
                formRef.current.setFieldValue("timeEnd", searchParams.get("te"));
            }
            if (searchParams.get("g")) {
                formRef.current.setFieldValue("grade", searchParams.get("g"));
            }
            if (searchParams.get("c")) {
                formRef.current.setFieldValue("nameClass", searchParams.get("c"));
            }
            if (searchParams.get("e")) {
                let eIds = searchParams.get("e").split(",");
                let equipment = json.equipment.filter(item => {
                    if (eIds.indexOf(item.EquipmentID.toString()) > -1) {
                        return true;
                    }
                    return false;
                }).map(item => {
                    return { value: item.EquipmentID, label: item.Description };
                });
                formRef.current.setFieldValue("equipment", equipment);
            }
            if (searchParams.get("ca")) {
                let cIds = searchParams.get("ca").split(",");
                let category = json.categories.filter(item => {
                    if (cIds.indexOf(item.CategoryID.toString()) > -1) {
                        return true;
                    }
                    return false;
                }).map(item => {
                    return { value: item.CategoryID, label: item.Description };
                });
                formRef.current.setFieldValue("categories", category);
            }
            if (searchParams.get("ex")) {
                formRef.current.setFieldValue("expiration", searchParams.get("ex"));
            }
            if (searchParams.get("co")) {
                let foundPerson = json.contactPerson.find(item => item.ContactPersonID == searchParams.get("co"));
                if (foundPerson) {
                    formRef.current.setFieldValue("contactPerson", {value: foundPerson.ContactPersonID, label: foundPerson.FirstName + " " + foundPerson.LastName});
                }
            }
            if (searchParams.get("r")) {
                formRef.current.setFieldValue("room", true);
                formRef.current.setFieldValue("roomName", searchParams.get("r"));
            }

            if (searchParams.get("cr")) {
                formRef.current.setFieldValue("criminalRecord", true);
            }
        }

        const getSettings = async () => {
            try {
                let result = await request("/User/GetOrganisationSettings");
                let json = result.data;
                if (json.r != 1) {
                    if (json.message) {
                        aler.error(json.message);
                    }
                    else {
                        toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut");
                    }
                }
                else {
                    let defaultPerson = false;
                    let persons = json.contactPerson.map((val) => {
                        if (val.DefaultPerson == 1) {
                            defaultPerson = val;
                        }
                        return { value: val.ContactPersonID, label: val.FirstName + " " + val.LastName }
                    });

                    if (defaultPerson != false) {
                        persons.splice(0, 0, { value: 0, label: "Standard Ansprechpartner ( " + defaultPerson.FirstName + " " + defaultPerson.LastName + ")" });
                    }
                    

                    setEquipment(json.equipment.map((val) => { return { value: val.EquipmentID, label: val.Description } }));
                    setCategories(json.categories.map((val) => { return { value: val.CategoryID, label: val.Description } }));
                    setContactPersons(persons);

                    formRef.current.setFieldValue("equipment", json.oldEquipment.map((val) => { return { value: val.EquipmentID, label: val.Description } }));
                    formRef.current.setFieldValue("categories", json.oldCategories.map((val) => { return { value: val.CategoryID, label: val.Description } }));
                    formRef.current.setFieldValue("expiration", json.organisation.ExpireTimeDefault);

                    if (defaultPerson != false) {
                        formRef.current.setFieldValue("contactPerson", { value: 0, label: "Standard Ansprechpartner ( " + defaultPerson.FirstName + " " + defaultPerson.LastName + ")" });                    
                    }
                    else {
                        formRef.current.setFieldValue("contactPerson", { value: json.contactPerson[0].ContactPersonID, label: json.contactPerson[0].FirstName + " " + json.contactPerson[0].LastName });                    
                    }

                    setSearchParameter(json);
                }
            }
            catch (e) {
                toast.error("Fehler beim Laden.");
            }
        }  
        getSettings();
    }, []);

    const sortedCategories = useMemo(() => categories.sort((a, b) => {
        const nameA = a.label.toUpperCase();
        const nameB = b.label.toUpperCase();
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
    }), [categories]);

    const sortedEquipment = useMemo(() => equipment.sort((a, b) => {
        const nameA = a.label.toUpperCase();
        const nameB = b.label.toUpperCase();
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
    }), [equipment]);

    return (
        <Formik
            innerRef={(f) => formRef.current = f}
            validationSchema={
                yup.object().shape(schema)
            }
            onSubmit = {(values) => {
                createTimeslot(values);
            }}
            initialValues={{
                date: '',
                timeStart: '',
                timeEnd: '',
                grade: 5,
                nameClass: '',
                room: false,
                roomName: '',
                equipment: [],
                categories: [],
                expiration: 24,
                contactPerson: '',
                criminalRecord: false,
            }}
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
            }) => (
                <Form noValidate onSubmit={handleSubmit}>
                    <Row>
                        <Col xs={12} sm={6}>
                            <Form.Group className="form-group" controlId="date">
                                <Form.Label className="required">Datum</Form.Label><Tooltip name="termin-datum" />
                                <Form.Control isInvalid={errors.date && touched.date} type="date" placeholder="" name="date" value={values.date} onBlur={handleBlur} onChange={handleChange} />
                                <Form.Control.Feedback type="invalid">
                                    {errors.date}
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Row className="form-group">
                                <Col xs={12} sm={6} className="mb-3 mb-sm-0">
                                    <Form.Group controlId="timeStart">
                                        <Form.Label className="required">Anfangszeit</Form.Label><Tooltip name="termin-start" />
                                        <Form.Control isInvalid={errors.timeStart && touched.timeStart} type="time" placeholder="" name="timeStart" value={values.timeStart} onBlur={handleBlur} onChange={(e) => { setStartTime(e.target.value); handleChange(e); }} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.timeStart}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} sm={6}>
                                    <Form.Group controlId="timeEnd">
                                        <Form.Label className="required">Endzeit</Form.Label><Tooltip name="termin-ende" />
                                        <Form.Control isInvalid={errors.timeEnd && touched.timeEnd} type="time" placeholder="" name="timeEnd" value={values.timeEnd} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.timeEnd}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row className="form-group">
                                <Col xs={12} sm={6} className="mb-3 mb-sm-0">
                                    <Form.Group controlId="grade">
                                        <Form.Label className="required">Stufe</Form.Label><Tooltip name="termin-stufe" />
                                        <Form.Control isInvalid={errors.grade && touched.grade} type="number" step="1" min="5" max="13" placeholder="" name="grade" value={values.grade} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.grade}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col xs={12} sm={6}>
                                    <Form.Group controlId="nameClass">
                                        <Form.Label className="required">Klassen- oder Kursbezeichnung</Form.Label><Tooltip name="termin-klassen" />
                                        <Form.Control isInvalid={errors.nameClass && touched.nameClass} type="text" placeholder="" name="nameClass" value={values.nameClass} onBlur={handleBlur} onChange={handleChange} />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.nameClass}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Form.Group className="form-group" controlId="room">
                                <Form.Check type="checkbox" label="Raumbezeichnung" checked={values.room} onChange={handleChange} />
                            </Form.Group>

                            {values.room && (
                                <Form.Group className="form-group" controlId="roomName">
                                    <Form.Label>Raumbezeichnung</Form.Label><Tooltip name="termin-raumbezeichnung" />
                                    <Form.Control isInvalid={errors.roomName && touched.roomName} type="text" placeholder="" name="roomName" value={values.roomName} onChange={handleChange} />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.roomName}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            )}
                        </Col>
                        <Col xs={12} sm={6}>
                            <Form.Group className="form-group" controlId="contactPerson">
                                <Form.Label className="required">Kontaktperson</Form.Label><Tooltip name="termin-kontaktperson" />
                                <Select name="contactPerson" classNamePrefix="bv-select" className="bv-select" options={contactPersons} value={values.contactPerson} classname="basic-select" onChange={
                                    (values) => {
                                        formRef.current.setFieldValue("contactPerson", values);
                                    }
                                } />
                            </Form.Group>

                            <Form.Group className="form-group" controlId="equipment">
                                <Form.Label className="required">Ausstattung</Form.Label><Tooltip name="termin-ausstattung" />
                                <Select isMulti closeMenuOnSelect={false} name="Equipment" classNamePrefix="bv-select" className="bv-select" options={sortedEquipment} value={values.equipment} classname="basic-multi-select" placeholder="Bitte ausw&auml;hlen" onChange={
                                    (values) => {
                                        formRef.current.setFieldValue("equipment", values);
                                    }
                                } />
                            </Form.Group>

                            <Form.Group className="form-group" controlId="expiration">
                                <Form.Label className="required">Ablaufzeit (in Stunden vor Termin-Begin)</Form.Label><Tooltip name="termin-ablaufzeit" />
                                <Form.Control isInvalid={errors.expiration && touched.expiration} type="number" step="1" value={values.expiration} onBlur={handleBlur} onChange={handleChange} />
                                <Form.Control.Feedback type="invalid">
                                    {errors.expiration}
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group className="form-group" controlId="categories">
                                <Form.Label className="required">NICHT erwünschte Betriebskategorien</Form.Label><Tooltip name="termin-nicht-erwünschte" />
                                <Select isMulti closeMenuOnSelect={false} name="Categories" classNamePrefix="bv-select" className="bv-select" options={sortedCategories} value={values.categories} classname="basic-multi-select" placeholder="Bitte ausw&auml;hlen" onChange={
                                    (values) => {
                                        formRef.current.setFieldValue("categories", values);
                                    }
                                } />
                            </Form.Group>

                            {/*<Form.Group className="form-group" controlId="criminalRecord">
                                <Form.Check type="checkbox" label="Erweitertes Führungszeugnis muss vorliegen" checked={values.criminalRecord} onChange={handleChange} />
                            </Form.Group>*/}
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col>
                            <Button variant="secondary" type="submit">
                                <i className="fa-solid fa-right-to-bracket mr-2"></i>Termin erstellen
                            </Button>
                        </Col>
                    </Row>

                    <MandatoryFieldNotice />
                </Form>
            )}
        </Formik>
    );
}

export default CreateTimeslot;